// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { Editor } from "primereact/editor";
// import 'primereact/resources/themes/saga-blue/theme.css'; // Import PrimeReact Theme
// import 'primereact/resources/primereact.min.css'; // Import PrimeReact CSS
// import 'primeicons/primeicons.css'; // Import PrimeIcons
// import config from "../../config";

// function AddNewBlog() {
//   const navigate = useNavigate();
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: '',
//     description: '',
//     featuredImage: null,
//     galleryImages: null,
//   });


//   const [centerContent, setCenterContent] = useState([
//     { title: '', description: '' }
//   ]);

//   const handleContentChange = (index, event) => {
//     const newFields = centerContent.map((field, fieldIndex) => {
//       if (index === fieldIndex) {
//         return { ...field, [event.target.name]: event.target.value };
//       }
//       return field;
//     });
//     setCenterContent(newFields);
//   };

//   const addContentFields = () => {
//     setCenterContent([...centerContent, { title: '', description: '' }]);
//   };

//   const removeContentFields = (index) => {
//     const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
//     setCenterContent(newFields);
//   };

//   const handleInputChange = async (e) => {
//     const { name, value, files } = e;

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: files ? files : value
//     }));
//   };

//   const handleAddBlog = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     data.append('title', formData.title);
//     data.append('description', formData.description);
//     data.append('centerContent', JSON.stringify(centerContent));

//     if (formData.galleryImages) {
//       for (let i = 0; i < formData.galleryImages.length; i++) {
//         data.append('galleryImages', formData.galleryImages[i]);
//       }
//     }

//     if (formData.featuredImage) {
//       data.append('featuredImage', formData.featuredImage[0]);
//     }

//     try {
//       const response = await axios.post(`${config.BASE_URL}/api/admin/add-blog`, data, {
//         withCredentials: true,
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       if (response.status === 200) {
//         const token = localStorage.getItem('token');
//         if (token) {
//           navigate('/admin/blogs');
//         } else {
//           navigate('/admin/login');
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to add blog');
//     }
//   };
//   return (
//     <div className="dashboard">
//       <div className="container">
//         <h1 className="dash_title">Dashboard</h1>
//         <div className="main-section">
//           <div className="back_btn_wrap">
//             <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//           </div>
//           <div className="main-inner add_project_main">
//             <form onSubmit={handleAddBlog} encType="multipart/form-data">
//               <div className="form-login">
//                 <div className="add_field titleField">
//                   <h2>Title</h2>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 <div className="add_field textareaField">
//                   <h2>Description</h2>
//                   <textarea
//                     name="description"
//                     value={formData.description}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 <div className="add_field">
//                   <h2>Featured Image</h2>
//                   <div className="form-group">
//                     <div className="file-upload">
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="featuredImage"
//                         onChange={(e) => handleInputChange(e.target)}
//                         required
//                       />
//                       <i className="fa fa-camera i-pic-upload"></i>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="add_field textareaField repeaterFields">
//                   <h2>Center Content</h2>
//                   {centerContent.map((field, index) => (
//                     <div key={index} className="singleReapterFieldContent">
//                       <div className="add_field">
//                         <h2>Title</h2>
//                         <input
//                           name="title"
//                           type="text"
//                           value={field.title}
//                           placeholder="title"
//                           onChange={(event) => handleContentChange(index, event)}
//                         />
//                       </div>

//                       <div className="add_field">
//                         <h2>Description</h2>
//                         <input
//                           name="description"
//                           type="text"
//                           value={field.description}
//                           placeholder="Description"
//                           onChange={(event) => handleContentChange(index, event)}
//                         />
//                       </div>

//                       <button type="button" onClick={() => removeContentFields(index)}>
//                         Remove
//                       </button>
//                     </div>
//                   ))}
//                   <button type="button" onClick={addContentFields}>Add More</button>
//                 </div>
//               </div>

//               <div className="add_field">
//                   <h2>Gallery Images</h2>
//                   <div className="form-group">
//                     <div className="file-upload">
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="galleryImages"
//                         multiple
//                         onChange={(e) => handleInputChange(e.target)}
//                       />
//                       <i className="fa fa-camera i-pic-upload"></i>
//                     </div>
//                   </div>
//                 </div>

//               <div className="add_project">
//                 <button type="submit">Add Blog</button>
//               </div>

//             </form>
//             {error && <p className="error-message">{error}</p>}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddNewBlog;






// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import JoditEditor from 'jodit-react';
// import config from "../../config";

// function AddNewBlog() {
//   const navigate = useNavigate();
//   const [error, setError] = useState(null);

//   const [formData, setFormData] = useState({
//     title: '',
//     description: '',
//     featuredImage: null,
//     galleryImages: null,
//   });

//   const [centerContent, setCenterContent] = useState([
//     { title: '', description: '' }
//   ]);

//   // Jodit configuration
//   const config_jodit = {
//     readonly: false,
//     height: 300,
//     toolbar: true,
//     spellcheck: true,
//     language: 'en',
//     toolbarButtonSize: 'medium',
//     toolbarAdaptive: false,
//     showCharsCounter: true,
//     showWordsCounter: true,
//     showXPathInStatusbar: false,
//     askBeforePasteHTML: false,
//     askBeforePasteFromWord: false,
//     buttons: [
//       'source', '|',
//       'bold', 'italic', 'underline', '|',
//       'ul', 'ol', '|',
//       'outdent', 'indent', '|',
//       'font', 'fontsize', 'brush', '|',
//       'image', 'link', 'table', '|',
//       'align', 'undo', 'redo', '|',
//       'hr', 'eraser', 'copyformat', '|',
//       'symbol', 'fullsize',
//     ],
//     uploader: {
//       insertImageAsBase64URI: true
//     },
//     removeButtons: ['brush', 'file'],
//     showXPathInStatusbar: false,
//     showCharsCounter: true,
//     showWordsCounter: true,
//     allowTabNavigation: false,
//   };

//   const handleContentChange = (index, field, value) => {
//     const newFields = centerContent.map((content, fieldIndex) => {
//       if (index === fieldIndex) {
//         return { ...content, [field]: value };
//       }
//       return content;
//     });
//     setCenterContent(newFields);
//   };

//   const handleContentTitleChange = (index, event) => {
//     handleContentChange(index, 'title', event.target.value);
//   };

//   const handleContentDescriptionChange = (index, content) => {
//     handleContentChange(index, 'description', content);
//   };

//   const addContentFields = () => {
//     setCenterContent([...centerContent, { title: '', description: '' }]);
//   };

//   const removeContentFields = (index) => {
//     const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
//     setCenterContent(newFields);
//   };

//   const handleInputChange = async (e) => {
//     const { name, value, files } = e;

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: files ? files : value
//     }));
//   };

//   const handleMainDescriptionChange = (content) => {
//     setFormData((prevData) => ({
//       ...prevData,
//       description: content
//     }));
//   };

//   const handleAddBlog = async (e) => {
//     e.preventDefault();
//     const data = new FormData();
//     data.append('title', formData.title);
//     data.append('description', formData.description);
//     data.append('centerContent', JSON.stringify(centerContent));

//     if (formData.galleryImages) {
//       for (let i = 0; i < formData.galleryImages.length; i++) {
//         data.append('galleryImages', formData.galleryImages[i]);
//       }
//     }

//     if (formData.featuredImage) {
//       data.append('featuredImage', formData.featuredImage[0]);
//     }

//     try {
//       const response = await axios.post(`${config.BASE_URL}/api/admin/add-blog`, data, {
//         withCredentials: true,
//         headers: {
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       if (response.status === 200) {
//         const token = localStorage.getItem('token');
//         if (token) {
//           navigate('/admin/blogs');
//         } else {
//           navigate('/admin/login');
//         }
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || 'Failed to add blog');
//     }
//   };

//   return (
//     <div className="dashboard">
//       <div className="container">
//         <h1 className="dash_title">Dashboard</h1>
//         <div className="main-section">
//           <div className="back_btn_wrap">
//             <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
//           </div>
//           <div className="main-inner add_project_main">
//             <form onSubmit={handleAddBlog} encType="multipart/form-data">
//               <div className="form-login">
//                 <div className="add_field titleField">
//                   <h2>Title</h2>
//                   <input
//                     type="text"
//                     name="title"
//                     value={formData.title}
//                     onChange={(e) => handleInputChange(e.target)}
//                     required
//                   />
//                 </div>

//                 {/* <div className="add_field textareaField">
//                   <h2>Description</h2>
//                   <JoditEditor
//                     value={formData.description}
//                     config={config_jodit}
//                     onBlur={(content) => handleMainDescriptionChange(content)}
//                     onChange={(content) => {}}
//                   />
//                 </div> */}

//                 <div className="add_field">
//                   <h2>Featured Image</h2>
//                   <div className="form-group">
//                     <div className="file-upload">
//                       <input
//                         type="file"
//                         className="form-control"
//                         name="featuredImage"
//                         onChange={(e) => handleInputChange(e.target)}
//                         required
//                       />
//                       <i className="fa fa-camera i-pic-upload"></i>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="add_field textareaField repeaterFields">
//                   <h2> Content</h2>
//                   {centerContent.map((field, index) => (
//                     <div key={index} className="singleReapterFieldContent">
//                       {/* <div className="add_field">
//                         <h2>Title</h2>
//                         <input
//                           name="title"
//                           type="text"
//                           value={field.title}
//                           placeholder="Title"
//                           onChange={(event) => handleContentTitleChange(index, event)}
//                         />
//                       </div> */}

//                       {/* <div className="add_field"> */}
//                         <h2>Description {index+1}</h2>
//                         <JoditEditor
//                           value={field.description}
//                           config={config_jodit}
//                           onBlur={(content) => handleContentDescriptionChange(index, content)}
//                           onChange={(content) => {}}
//                         />
//                       {/* </div> */}

//                       <button type="button" onClick={() => removeContentFields(index)}>
//                         Remove
//                       </button>
//                     </div>
//                   ))}
//                   <button type="button" onClick={addContentFields}>Add More</button>
//                 </div>
//               </div>

//               <div className="add_field">
//                 <h2>Gallery Images</h2>
//                 <div className="form-group">
//                   <div className="file-upload">
//                     <input
//                       type="file"
//                       className="form-control"
//                       name="galleryImages"
//                       multiple
//                       onChange={(e) => handleInputChange(e.target)}
//                     />
//                     <i className="fa fa-camera i-pic-upload"></i>
//                   </div>
//                 </div>
//               </div>

//               <div className="add_project">
//                 <button type="submit">Add Blog</button>
//               </div>

//             </form>
//             {error && <p className="error-message">{error}</p>}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default AddNewBlog;











import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import JoditEditor from 'jodit-react';
import config from "../../config";

function AddNewBlog() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [activeLanguage, setActiveLanguage] = useState('en');

  // Main form data for English (default)
  const [formData, setFormData] = useState({
    language: 'en',
    title: '',
    description: '',
    featuredImage: null,
    galleryImages: null,
    // slug: ''
  });

  // Spanish translation data
  const [spanishData, setSpanishData] = useState({
    language: 'es',
    title: '',
    description: '',
    featuredImage: '',
    // slug: ''
  });

  // Content sections for English
  const [centerContent, setCenterContent] = useState([
    { title: '', description: '' }
  ]);

  // Content sections for Spanish
  const [spanishCenterContent, setSpanishCenterContent] = useState([
    { title: '', description: '' }
  ]);

  // Jodit configuration
  const config_jodit = {
    readonly: false,
    height: 300,
    toolbar: true,
    spellcheck: true,
    language: activeLanguage,
    toolbarButtonSize: 'medium',
    toolbarAdaptive: false,
    showCharsCounter: true,
    showWordsCounter: true,
    showXPathInStatusbar: false,
    askBeforePasteHTML: false,
    askBeforePasteFromWord: false,
    buttons: [
      'source', '|',
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'outdent', 'indent', '|',
      'font', 'fontsize', 'brush', '|',
      'image', 'link', 'table', '|',
      'align', 'undo', 'redo', '|',
      'hr', 'eraser', 'copyformat', '|',
      'symbol', 'fullsize',
    ],
    uploader: {
      insertImageAsBase64URI: true
    },
    removeButtons: ['brush', 'file'],
    showXPathInStatusbar: false,
    showCharsCounter: true,
    showWordsCounter: true,
    allowTabNavigation: false,
  };

  // Handle language tab switching
  const switchLanguage = (lang) => {
    setActiveLanguage(lang);
  };

  // English content handlers
  const handleContentChange = (index, field, value) => {
    const newFields = centerContent.map((content, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...content, [field]: value };
      }
      return content;
    });
    setCenterContent(newFields);
  };

  const handleContentTitleChange = (index, event) => {
    handleContentChange(index, 'title', event.target.value);
  };

  const handleContentDescriptionChange = (index, content) => {
    handleContentChange(index, 'description', content);
  };

  const addContentFields = () => {
    setCenterContent([...centerContent, { title: '', description: '' }]);
  };

  const removeContentFields = (index) => {
    const newFields = centerContent.filter((field, fieldIndex) => index !== fieldIndex);
    setCenterContent(newFields);
  };

  // Spanish content handlers
  const handleSpanishContentChange = (index, field, value) => {
    const newFields = spanishCenterContent.map((content, fieldIndex) => {
      if (index === fieldIndex) {
        return { ...content, [field]: value };
      }
      return content;
    });
    setSpanishCenterContent(newFields);
  };

  const handleSpanishContentTitleChange = (index, event) => {
    handleSpanishContentChange(index, 'title', event.target.value);
  };

  const handleSpanishContentDescriptionChange = (index, content) => {
    handleSpanishContentChange(index, 'description', content);
  };

  const addSpanishContentFields = () => {
    setSpanishCenterContent([...spanishCenterContent, { title: '', description: '' }]);
  };

  const removeSpanishContentFields = (index) => {
    const newFields = spanishCenterContent.filter((field, fieldIndex) => index !== fieldIndex);
    setSpanishCenterContent(newFields);
  };

  // Main form handlers
  const handleInputChange = async (e) => {
    const { name, value, files } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : value
    }));
  };

  const handleMainDescriptionChange = (content) => {
    setFormData((prevData) => ({
      ...prevData,
      description: content
    }));
  };

  // Spanish form handlers
  const handleSpanishInputChange = (e) => {
    const { name, value } = e.target;
    setSpanishData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSpanishDescriptionChange = (content) => {
    setSpanishData((prevData) => ({
      ...prevData,
      description: content
    }));
  };

  // Form submission
  const handleAddBlog = async (e) => {
    e.preventDefault();
    const data = new FormData();
    
    // Main English data
    data.append('language', formData.language);
    data.append('title', formData.title);
    data.append('description', formData.description);
    // data.append('slug', formData.slug);
    data.append('centerContent', JSON.stringify(centerContent));

    // Spanish translation data
    const spanishDataWithContent = {
      ...spanishData,
      centerContent: spanishCenterContent
    };
    data.append('spanishData', JSON.stringify(spanishDataWithContent));

    // File uploads (shared between languages)
    if (formData.galleryImages) {
      for (let i = 0; i < formData.galleryImages.length; i++) {
        data.append('galleryImages', formData.galleryImages[i]);
      }
    }

    if (formData.featuredImage) {
      data.append('featuredImage', formData.featuredImage[0]);
    }

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/add-blog`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/blogs');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add blog');
    }
  };

  return (
    <div className="dashboard">
      <div className="container">
        <h1 className="dash_title">Dashboard</h1>
        <div className="main-section">
          <div className="back_btn_wrap">
            <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
          </div>
          <div className="main-inner add_project_main">
            
            {/* Language Tabs */}
            <div className="language-tabs" style={{ marginBottom: '20px' }}>
              <button 
                type="button" 
                className={`tab-btn ${activeLanguage === 'en' ? 'active' : ''}`}
                onClick={() => switchLanguage('en')}
                style={{
                  padding: '10px 20px',
                  marginRight: '10px',
                  backgroundColor: activeLanguage === 'en' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'en' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                English
              </button>
              <button 
                type="button" 
                className={`tab-btn ${activeLanguage === 'es' ? 'active' : ''}`}
                onClick={() => switchLanguage('es')}
                style={{
                  padding: '10px 20px',
                  backgroundColor: activeLanguage === 'es' ? '#007bff' : '#f8f9fa',
                  color: activeLanguage === 'es' ? 'white' : 'black',
                  border: '1px solid #ddd',
                  cursor: 'pointer'
                }}
              >
                Spanish
              </button>
            </div>

            <form onSubmit={handleAddBlog} encType="multipart/form-data">
              
              {/* English Content */}
              {activeLanguage === 'en' && (
                <div className="language-content">
                  <h3>English Content</h3>
                  
                  <div className="form-login">
                    <div className="add_field titleField">
                      <h2>Title (English)</h2>
                      <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Slug (English)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={formData.slug}
                        onChange={(e) => handleInputChange(e.target)}
                        placeholder="url-friendly-slug"
                      />
                    </div> */}

                    <div className="add_field textareaField">
                      <h2>Description (English)</h2>
                      <JoditEditor
                        value={formData.description}
                        config={config_jodit}
                        onBlur={(content) => handleMainDescriptionChange(content)}
                        onChange={(content) => {}}
                      />
                    </div>

                    <div className="add_field textareaField repeaterFields">
                      <h2>Content Sections (English)</h2>
                      {centerContent.map((field, index) => (
                        <div key={index} className="singleReapterFieldContent">
                          <div className="add_field">
                            <h3>Section {index + 1} Title</h3>
                            <input
                              name="title"
                              type="text"
                              value={field.title}
                              placeholder="Section Title"
                              onChange={(event) => handleContentTitleChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h3>Section {index + 1} Description</h3>
                            <JoditEditor
                              value={field.description}
                              config={config_jodit}
                              onBlur={(content) => handleContentDescriptionChange(index, content)}
                              onChange={(content) => {}}
                            />
                          </div>

                          <button type="button" onClick={() => removeContentFields(index)}>
                            Remove Section
                          </button>
                        </div>
                      ))}
                      <button type="button" onClick={addContentFields}>Add More Sections</button>
                    </div>
                  </div>
                </div>
              )}

              {/* Spanish Content */}
              {activeLanguage === 'es' && (
                <div className="language-content">
                  <h3>Spanish Content</h3>
                  
                  <div className="form-login">
                    <div className="add_field titleField">
                      <h2>Title (Spanish)</h2>
                      <input
                        type="text"
                        name="title"
                        value={spanishData.title}
                        onChange={handleSpanishInputChange}
                      />
                    </div>

                    {/* <div className="add_field titleField">
                      <h2>Slug (Spanish)</h2>
                      <input
                        type="text"
                        name="slug"
                        value={spanishData.slug}
                        onChange={handleSpanishInputChange}
                        placeholder="url-amigable-slug"
                      />
                    </div> */}

                    <div className="add_field textareaField">
                      <h2>Description (Spanish)</h2>
                      <JoditEditor
                        value={spanishData.description}
                        config={config_jodit}
                        onBlur={(content) => handleSpanishDescriptionChange(content)}
                        onChange={(content) => {}}
                      />
                    </div>

                    <div className="add_field textareaField repeaterFields">
                      <h2>Content Sections (Spanish)</h2>
                      {spanishCenterContent.map((field, index) => (
                        <div key={index} className="singleReapterFieldContent">
                          <div className="add_field">
                            <h3>Section {index + 1} Title</h3>
                            <input
                              name="title"
                              type="text"
                              value={field.title}
                              placeholder="Título de la Sección"
                              onChange={(event) => handleSpanishContentTitleChange(index, event)}
                            />
                          </div>

                          <div className="add_field">
                            <h3>Section {index + 1} Description</h3>
                            <JoditEditor
                              value={field.description}
                              config={config_jodit}
                              onBlur={(content) => handleSpanishContentDescriptionChange(index, content)}
                              onChange={(content) => {}}
                            />
                          </div>

                          <button type="button" onClick={() => removeSpanishContentFields(index)}>
                            Remove Section
                          </button>
                        </div>
                      ))}
                      <button type="button" onClick={addSpanishContentFields}>Add More Sections</button>
                    </div>
                  </div>
                </div>
              )}

              {/* Shared fields (shown on both tabs) */}
              <div className="shared-fields">
                <div className="add_field">
                  <h2>Featured Image</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="featuredImage"
                        onChange={(e) => handleInputChange(e.target)}
                        required
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>

                <div className="add_field">
                  <h2>Gallery Images</h2>
                  <div className="form-group">
                    <div className="file-upload">
                      <input
                        type="file"
                        className="form-control"
                        name="galleryImages"
                        multiple
                        onChange={(e) => handleInputChange(e.target)}
                      />
                      <i className="fa fa-camera i-pic-upload"></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="add_project">
                <button type="submit">Add Blog</button>
              </div>

            </form>
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddNewBlog;